import React from 'react';
import PropTypes from 'prop-types';
import relationships from 'facet-rest/src/consts/relationships';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { withTheme } from '@material-ui/core/styles';
import { AchRelationshipResourceOverride } from 'Resources/Apex';
import { getApexACHRelationshipStatusColor } from 'Consts/Apex';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import View from './View';
import { useApexAdminPortalDispatchContext } from '../../ApexAdminPortalContext';
import { setAchRelationshipResource, setInvestigationResource } from '../../ApexAdminPortalActions';

const AchRelationships = ({
  resource: accountCreationRequestResource,
}) => {
  const apexAdminPortalDispatch = useApexAdminPortalDispatchContext();
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [achRelationshipCollection, setAchRelationshipCollection] = React.useState(null);
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'ACH Relationship' });

  const fetchClearingHouseAccounts = async () => {
    try {
      setLoading(true);
      const newCollection = await accountCreationRequestResource.relationship(relationships.achRelationships.name).link('related').Get();
      setAchRelationshipCollection(newCollection.overrideMeta(AchRelationshipResourceOverride));
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  };
  const refreshRows = () => {
    const newRows = [];
    // eslint-disable-next-line no-unused-expressions
    achRelationshipCollection?.resources()?.list().forEach((achResource) => {
      newRows.push({
        status: achResource.meta().field('status').selectedOption()?.attr('prompt') || '',
        statusColors: getApexACHRelationshipStatusColor(achResource.attr('status')),
        bankAccountType: achResource.attr('bankAccountType'),
        nickName: achResource.attr('nickname'),
        activeStatus: achResource.attr('isActive') === 'true' ? 'Active' : 'Inactive',
        resource: achResource,
      });
    });
    setRows(newRows);
  };
  const onClickAchRelationship = (resource) => {
    setAchRelationshipResource(resource, apexAdminPortalDispatch);
    setInvestigationResource(null, apexAdminPortalDispatch);
  };

  React.useEffect(() => {
    if (accountCreationRequestResource?.relationship(relationships.achRelationships.name)) {
      fetchClearingHouseAccounts();
    } else {
      setLoading(false);
    }
  }, [accountCreationRequestResource]);
  React.useEffect(() => {
    refreshRows();
  }, [achRelationshipCollection]);

  return (
    <View
      rows={rows}
      loading={loading}
      onClick={(collection) => {
        onClickAchRelationship(collection);
        logEvent('Click ACH Relationship');
      }}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

AchRelationships.propTypes = {
  resource: PropTypes.object,
};
AchRelationships.defaultProps = {
  resource: null,
};

export default withTheme(AchRelationships);
